import { IconProps, IconSize } from "../theme";

const Map = ({ size = IconSize.S }: IconProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 14 13"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.7927 1.22917C13.7282 1.17891 13.6531 1.144 13.5731 1.12709C13.4931 1.11018 13.4103 1.11171 13.331 1.13157L9.21644 2.16004L5.08712 0.0950352C4.97206 0.0376484 4.84027 0.0233236 4.71558 0.0546507L0.407885 1.13157C0.291394 1.16069 0.187979 1.22791 0.114074 1.32255C0.0401702 1.41718 1.81803e-05 1.53381 0 1.65388V11.3462C1.23878e-05 11.428 0.0186706 11.5088 0.0545575 11.5823C0.0904443 11.6558 0.142616 11.7202 0.20711 11.7705C0.271604 11.8209 0.346724 11.8559 0.426764 11.8729C0.506805 11.8898 0.58966 11.8883 0.669038 11.8685L4.78356 10.84L8.91288 12.905C8.98785 12.942 9.07027 12.9613 9.15385 12.9616C9.19787 12.9615 9.24172 12.9561 9.28442 12.9454L13.5921 11.8685C13.7086 11.8394 13.812 11.7722 13.8859 11.6775C13.9598 11.5829 14 11.4663 14 11.3462V1.65388C14 1.57199 13.9814 1.49116 13.9454 1.41757C13.9095 1.34397 13.8573 1.27954 13.7927 1.22917ZM4.84615 9.7308C4.80213 9.73083 4.75828 9.73626 4.71558 9.74696L1.07692 10.6563V2.07455L4.78356 1.14773L4.84615 1.17869V9.7308ZM12.9231 10.9255L9.21644 11.8523L9.15385 11.8214V3.26927C9.19784 3.26946 9.24169 3.26426 9.28442 3.25378L12.9231 2.34379V10.9255Z"
        fill="#071443"
      />
    </svg>
  );
};

export default Map;
